import { Mode } from '@arhs-fleetback/types/entities/common';

import { ExtensionEnum } from 'modules/global/typing/enums/extensions.enum';
import { uniq } from 'utils/ObjectUtils';

export const DeviceTypeEnum = {
  ANDROID: 'ANDROID',
  API_CONNECTOR: 'API_CONNECTOR',
  CONNECTOR: 'CONNECTOR',
  FTP_CONNECTOR: 'FTP_CONNECTOR',
  IOS: 'IOS',
  TVOS: 'TVOS',
  UNKNOWN: 'UNKNOWN',
} as const;

export type DeviceTypeEnum = typeof DeviceTypeEnum[keyof typeof DeviceTypeEnum];

export const DeviceStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export type DeviceStatusEnum = typeof DeviceStatusEnum[keyof typeof DeviceStatusEnum];

export const DeviceTargetEnum = {
  CONNECTOR: 'CONNECTOR',
  FLEETBACK: 'FLEETBACK',
  FLEETBACKTV: 'FLEETBACKTV',
} as const;

export type DeviceTargetEnum = typeof DeviceTargetEnum[keyof typeof DeviceTargetEnum];

export const DeviceOwnershipEnum = {
  PERSONAL: 'PERSONAL',
  SHARED: 'SHARED',
} as const;

export type DeviceOwnershipEnum = typeof DeviceOwnershipEnum[keyof typeof DeviceOwnershipEnum];

// FE-only target value (not in BE DeviceTargetEnum). Used for app type filtering on device dashboard.
export const DEVICE_TARGET_ODITOO = 'ODITOO';

export const DEVICES_TYPE_SHOWN = [
  DeviceTypeEnum.IOS,
  DeviceTypeEnum.ANDROID,
  DeviceTypeEnum.TVOS,
  DeviceTypeEnum.UNKNOWN,
];

export const OTHERS = 'OTHERS';

export const DEVICE_TYPES_BY_EXTENSIONS = {
  [DeviceOwnershipEnum.PERSONAL]: [
    ExtensionEnum.AFTER_SALES,
    ExtensionEnum.SALES,
    ExtensionEnum.PARTS,
    ExtensionEnum.AUDIT,
    ExtensionEnum.SELF_SERVICE,
  ],
  [DeviceOwnershipEnum.SHARED]: [
    ExtensionEnum.AFTER_SALES,
    ExtensionEnum.SALES,
    ExtensionEnum.PARTS,
    ExtensionEnum.AUDIT,
  ],
};

export const EXTENSION_BY_MODE = {
  [Mode.TECHNICIAN]: ExtensionEnum.AFTER_SALES,
  [Mode.PARTS]: ExtensionEnum.PARTS,
  [Mode.SALES]: ExtensionEnum.SALES,
  [Mode.AUDIT]: ExtensionEnum.AUDIT,
};

export const ALLOWED_DEVICE_EXTENSIONS = uniq(Object.values(DEVICE_TYPES_BY_EXTENSIONS).flat());
